var React = require('react');

function Note (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3,15 L6,15 L6,16 L3,16 L2,16 L2,2 L2,1 L3,1 L3,0 L4,0 L4,1 L6,1 L6,0 L7,0 L7,1 L9,1 L9,0 L10,0 L10,1 L12,1 L12,0 L13,0 L13,1 L14,1 L14,2 L14,6 L13,6 L13,2 L3,2 L3,15 Z M13.6064378,7.18748304 L13.7046899,7.11212527 C15.0497949,6.3237522 16.6804346,8.15467651 15.7650058,9.50929993 L10.2295507,15.0796661 L6.92201907,16.0040585 L8.056846,12.6602074 L13.6064378,7.18748304 Z M8.47800534,14.5308692 L9.70655113,14.187514 L14.9944744,8.87927463 C15.2614759,8.47926217 14.6649892,7.78505163 14.2541979,7.95314862 L8.92767022,13.2058986 L8.47800534,14.5308692 Z"}));
}

Note.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Note;

Note.default = Note;
